import React, { useState } from "react";
import Footer from './Footer';
import Customizer from "./Customizer";
import Navbar from "./Navbar";
import Topbar from "./Topbar";
// import Breadcrumbs from "../components/Breadcrumbs";
import Breadcrumbs from "../Hooks/Breadcrumbs";
import MyChatbot from "../components/chatbot/MyChatbot";

const Layout = ({children}) => {

	const [isSideToggled, setSideToggled] = useState(false);

	const handlesideToggle = () => {
		setSideToggled(!isSideToggled);
	};
	return (
		<>
			<div className= {`wrapper  ${isSideToggled ? "toggled" : ""}` }>   
				<div className="sidebar-wrapper " data-simplebar="true">
					<div className="sidebar-header">
						<div>
							<h4 className="logo-text" onClick={handlesideToggle}>Member</h4>
						</div>
						<div>
							<h4 className="logo-text">Panel</h4>
						</div>
						<div className="toggle-icon ms-auto"><i className='bx bx-arrow-to-left' onClick={handlesideToggle}></i>
						</div>
					</div>

					<Navbar/>
				</div>
				<Topbar handlesideToggle={handlesideToggle}/>
				<div className="page-wrapper">
					<div className="page-content">
					<Breadcrumbs />
						{children}
					</div>
				</div>
				<div className="overlay toggle-icon"></div>
				<a href="javaScript:;" className="back-to-top"><i className='bx bxs-up-arrow-alt'></i></a>
				<Footer/>
			</div>
			<Customizer/>
			<MyChatbot />
		</>
	);
}
export default Layout;